import { useMemo } from 'react';
import { envConfig } from '../../../configs/env';
import { useAppStore } from '../../hooks/store-hooks';

export function Reports() {
    const store = useAppStore();
    const url = useMemo(() => `${envConfig.service}/ort/?isDark=${store.getState().settings.isDark}`, []);

    return <iframe data-auto-sync-theme className="w-100 h-100" src={url} />;
}
